import { autoPlayService } from '../../autoPlay'
import { ApiError } from '../../errorHandle/model/ApiError'
import { ErrorType } from '../../errorHandle/model/ErrorType'
import { setErrorPopupData } from '../../errorHandle/util/errorPopupUtil'
import { usePlayerStore } from '../../player/store/playerStore'
import { SingleFlight } from '../../../util/singleFlight'
import { IEndGameApi } from '../api/endGameApi'
import { useEndGameStore } from '../store/endGameStore'

export class EndGameService {
  private _api: IEndGameApi
  private _singleFlight = new SingleFlight<void>()

  constructor(api: IEndGameApi) {
    this._api = api
  }

  /**
   * 動畫播完（machine 回到 init game）時結算延遲結算的注單。
   * 失敗時保留 isSettled = false，下一轉下注前的閘門會再重試；
   * 超過 30 分鐘後端 AutoSettle 也會自動結算。
   */
  async endGameIfNeeded() {
    const { refNo, isSettled } = useEndGameStore.getState()
    if (isSettled || refNo === '') return
    await this._singleFlight.run(() => this.settle(refNo))
  }

  /** 下一轉下注前的閘門：上一單 EndGame 必須完成，未完成先重試、仍失敗就中斷這次 spin */
  async ensureSettledBeforeNextSpin() {
    await this.endGameIfNeeded()
    if (!useEndGameStore.getState().isSettled) {
      autoPlayService.cancel()
      setErrorPopupData(ErrorType.SystemError)
      throw new ApiError(ErrorType.SystemError)
    }
  }

  private async settle(refNo: string) {
    try {
      const res = await this._api.endGame({ refNo })
      useEndGameStore.setState({ isSettled: true })
      if (res.isSettled) {
        usePlayerStore.setState({ lastSettledBalance: res.settledBalance })
      }
    }
    catch (e) {
      console.error('endGame failed', e)
    }
  }
}
